import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import posed from 'react-pose'
import LoadingSpinner from '~/components/traffic-tickets/LoadingSpinner'

const Image = styled.img`
  ${props => (props.position === 'right' ? 'margin-left: 16px;' : null)}
  ${props => (props.position === 'left' ? 'margin-right: 16px;' : null)}
`

const SpinnerBox = styled.div`
  height: 30px;
  width: 30px;
`

const BOX_STYLES = {
  disabled: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #a9cbe8 0%, #a9cbe8 100%)'
  },
  init: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #5ebefa 0%, #3089f3 100%)'
  },
  hover: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #3089f3 0%, #5ebefa 100%)'
  },
  press: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #3089f3 0%, #5ebefa 100%)'
  }
}

const Box = posed.button({
  hoverable: true,
  pressable: true,
  focusable: true,
  init: {
    ...BOX_STYLES.init
  },
  focus: {
    ...BOX_STYLES.hover,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.hover.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.hover.background
  },
  hover: {
    ...BOX_STYLES.hover,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.hover.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.hover.background
  },
  press: {
    ...BOX_STYLES.press,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.press.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.press.background
  },
  disabled: {
    ...BOX_STYLES.disabled
  }
})

const StyledBox = styled(Box)`
  outline: none;
  -webkit-tap-highlight-color: transparent;
  background: #ffffff;
  border: none;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${props => props.width ? props.width : '227px'};
  height: 60px;
  padding: 17px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  color: #FFFFFF;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.125rem;
  user-select: none;
  transition: all 0.5s ease;
`
const NextButton = ({
  onClick,
  text,
  image,
  position,
  isMobile,
  disabled,
  type,
  isLoading,
  width
}) => {
  const imgProps = {
    position,
    src: image
  }
  return (
    <StyledBox
      pose={disabled ? 'disabled' : 'init'}
      isMobile={isMobile}
      onClick={onClick}
      disabled={disabled}
      type={type}
      width={width}
    >
      <>
        {isLoading ? <LoadingSpinner /> : 
          <>
            {image && position === 'left' ? <Image {...imgProps} /> : null}
            {text}
            {image && position === 'right' ? <Image {...imgProps} /> : null}
          </>
        }
      </>
    </StyledBox>
  )
}

NextButton.defaultProps = {
  position: 'right',
  isMobile: false,
  disabled: false,
  disabledText: null,
  image: null,
  type: 'button'
}

NextButton.propTypes = {
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  position: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default NextButton
